import React, { FC, useContext } from "react";
import { Member } from "../../backendProxies";
import { TranslationContext } from "../../context/TranslationContext";
import useToast from "../../hooks/useToast";

type Props = {
  member: Member;
  cb: () => void;
};

const MatchButtons: FC<Props> = ({ member, cb }) => {
  const { i } = useContext(TranslationContext);
  const { openToast } = useToast();
  const handleDecline = () => {
    member.declineDateMe().then((response) => {
      if (response.http_code !== 200) {
        openToast({
          title: i("Error"),
          description: response.message,
          type: "error",
        });
      } else {
        cb();
      }
    });
  };

  const handleLike = () => {
    member.acceptDateMe().then((response) => {
      if (response.http_code !== 200) {
        openToast({
          title: i("Error"),
          description: response.message,
          type: "error",
        });
      } else {
        cb();
      }
    });
  };

  return (
    <div className="@container MatchButton flex w-full space-x-2 md:px-4 gap-0 items-center justify-center ">
      <MatchButton
        onClick={handleDecline}
        className=" text-custom-red  bg-white"
      >
        <img
          src="/app/assets/Icons/deslikeHeart.svg"
          alt="Dislike icon"
          className="h-5 w-5"
        />
        <span className="capitalize hidden @[250px]:inline">
          {i("decline")}
        </span>
      </MatchButton>

      <MatchButton
        onClick={handleLike}
        className="bg-gradient-to-r from-custom-gradient-orange to-custom-red text-white"
      >
        <img
          src="/app/assets/Icons/likeHeart.svg"
          alt="Like icon"
          className="h-5 w-5"
        />
        <span className="capitalize hidden @[250px]:inline">{i("like")}</span>
      </MatchButton>
    </div>
  );
};

function MatchButton({
  children,
  onClick,
  className,
}: {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-center gap-2 px-3.5 w-full max-w-[100px] @xs:max-w-[140px] py-3 rounded-[10px] cursor-pointer font-semibold text-sm @xs:text-base shadow-md transition-opacity hover:opacity-90 ${className}`}
    >
      {children}
    </button>
  );
}

export default MatchButtons;
